import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {

  private principalURL = environment.apiUrl

  constructor(private http: HttpClient) { }

  createEmployee(EMPLOYEE: any)
  {
    return this.http.post<any>(`${this.principalURL}/employee/create`, EMPLOYEE)   
  }
  getEmployeeCalendar()
  {
    return this.http.get<any>(`${this.principalURL}/employee/employeeCalendar`)
  }

  getTareaResponsables()
  {
    return this.http.get<any[]>(`${this.principalURL}/employee/tarea-responsables`)
  }

  getAllActive()
  {
    return this.http.get<any[]>(`${this.principalURL}/employee/allActive`)
  }

  getAllActiveDelegadas()
  {
    return this.http.get<any[]>(`${this.principalURL}/employee/allActiveDelegadas`)
  }

  getEmployee()
  {
    return this.http.get<any>(`${this.principalURL}/employee`)   
  }

  getEmployeeName()
  {
    return this.http.get<any>(`${this.principalURL}/employee/nombres`)   
  }



  getEmployeeByID(EMPLOYEE_ID: any)
  {
    return this.http.post<any>(`${this.principalURL}/employee`,{EMPLOYEE_ID})   
  }

  getEmployeeID()
  {
    return this.http.get<any>(`${this.principalURL}/employee/employeeId`,)   
  }
  
  updateEmployee(EMPLOYEE_ID: any, changes :any)
  {
    return this.http.post<any>(`${this.principalURL}/employee/update`, {EMPLOYEE_ID, changes })   
  }

  updateEmployeePass(EMPLOYEE_ID: any, currentPassword:any, newPassword:any)
  {
    return this.http.post<any>(`${this.principalURL}/employee/updatePass`, {EMPLOYEE_ID, currentPassword, newPassword})   
  }

  resetEmployee(EMPLOYEE_ID: any)
  {
    return this.http.post<any>(`${this.principalURL}/employee/reset`, {EMPLOYEE_ID})   
  }



}
